import { DateTime } from "luxon";

export const MANAGEMENT_PERIOD_PICKER_OFFSET = 4;
export const MANAGEMENT_PERIOD_PICKER_STEP = 9;

export type ManagementPeriodMode = "week" | "month";

export function buildManagementWeekPickerOptions(center: DateTime): DateTime[] {
  const start = center.minus({ weeks: MANAGEMENT_PERIOD_PICKER_OFFSET }).startOf("week");

  return Array.from({ length: MANAGEMENT_PERIOD_PICKER_OFFSET * 2 + 1 }, (_, index) =>
    start.plus({ weeks: index })
  );
}

export function buildManagementMonthPickerOptions(center: DateTime): DateTime[] {
  const january = center.startOf("year");

  return Array.from({ length: 12 }, (_, index) => january.plus({ months: index }));
}

export function isSameManagementWeek(a: DateTime, b: DateTime): boolean {
  return a.startOf("week").toISODate() === b.startOf("week").toISODate();
}

export function isSameManagementMonth(a: DateTime, b: DateTime): boolean {
  return a.startOf("month").toISODate() === b.startOf("month").toISODate();
}

export function formatManagementPeriodLabel(
  mode: ManagementPeriodMode,
  anchor: DateTime,
  locale = "en"
): string {
  const localized = anchor.setLocale(locale);
  if (mode === "week") {
    const end = localized.plus({ days: 6 });
    return `${localized.toFormat("dd LLL")} – ${end.toFormat("dd LLL yyyy")}`;
  }
  return localized.toFormat("LLLL yyyy");
}

/**
 * Short chart axis / tooltip day label (e.g. "Mon 13/07" / "Mo. 13/07").
 * Landing month grain uses day-of-month only ("13").
 */
export function formatManagementChartDayLabel(
  isoDate: string,
  language = "en",
  dayOfMonthOnly = false
): string {
  const day = DateTime.fromISO(isoDate);
  if (!day.isValid) {
    return isoDate;
  }
  const localized = day.setLocale(language);
  if (dayOfMonthOnly) {
    return localized.toFormat("d");
  }
  return localized.toFormat("ccc dd/LL");
}
